import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

export interface CreateTokenPayload {
  name: string;
  type: string;
  years_valid: number;
}

export function useCreateToken() {
  const queryClient = useQueryClient();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return useMutation<any, AxiosError<BaseError>, CreateTokenPayload>(
    async (payload: CreateTokenPayload) => {
      const { name, type, years_valid } = payload;
      const url = '/api/v3/tokens';
      const response = await Axios.post(url, { name, type, years_valid });
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('tokens');
      },
      useErrorBoundary: false
    }
  );
}
